import React, { useState } from "react";
import styles from "./style.module.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

import cx from "classnames";
import { Input, InputGroup, InputGroupText } from "reactstrap";

const PasswordInput = (props) => {
  const { className, inputProps, name, placeholder, onChange, onBlur, value,
    isDisabled, id, inputErrors = false } = props;
  const [showPassword, setShowPassword] = useState(false);

  const triggerOnChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  }

  return (
    <InputGroup>
      <InputGroupText>
        <FontAwesomeIcon icon="fa-solid fa-lock" />
      </InputGroupText>
      <Input
        {...inputProps}
        disabled={isDisabled}
        name={name}
        value={value}
        autoComplete="off"
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        id={id}
        className={cx(
          {
            className: className
          }
        )}
        onBlur={onBlur}
        onChange={(e) => triggerOnChange(e)} >
      </Input>
      <InputGroupText className={styles.visibilityToggle} onClick={(e) => { setShowPassword(!showPassword) }}>
        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
      </InputGroupText>
      {inputErrors}
    </InputGroup>
  );
}

export default PasswordInput;